<template>
  <div class="el-button-helper">
    <template v-if="link">
      <a
        :disabled="buttonDisabled || loading"
        :autofocus="autofocus"
        :type="nativeType"
        :class="classNames"
        :href="link"
      >
        <ButtonContent :loading="loading" :icon="icon">
          <slot />
        </ButtonContent>
      </a>
    </template>
    <template v-else-if="routerLink">
      <router-link
        :disabled="buttonDisabled || loading"
        :autofocus="autofocus"
        :type="nativeType"
        :class="classNames"
        :to="routerLink"
      >
        <ButtonContent :loading="loading" :icon="icon">
          <slot />
        </ButtonContent>
      </router-link>
    </template>
    <template v-else>
      <button
        :disabled="buttonDisabled || loading"
        :autofocus="autofocus"
        :type="nativeType"
        :class="classNames"
        @click="handleClick"
      >
        <ButtonContent :loading="loading" :icon="icon">
          <slot />
        </ButtonContent>
      </button>
    </template>
  </div>
</template>

<script>
const ButtonContent = {
  props: ["loading", "icon"],
  render(h) {
    return h("div", [
      this.loading ? h("i", { class: "el-icon-loading" }) : null,
      this.icon ? h("i", { class: this.icon }) : null,
      this.$slots.default ? h("span", this.$slots.default) : null
    ]);
  }
};

export default {
  name: "ElButton",
  components: {
    ButtonContent
  },

  inject: {
    elForm: {
      default: ""
    },
    elFormItem: {
      default: ""
    }
  },

  props: {
    link: {
      type: String,
      default: null
    },
    routerLink: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: "default"
    },
    size: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: ""
    },
    nativeType: {
      type: String,
      default: "button"
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean,
    round: Boolean,
    circle: Boolean,
    text: Boolean
  },

  computed: {
    elementType() {
      if (this.routerLink) {
        return "router-link";
      } else if (this.link) {
        return "a";
      } else {
        return "button";
      }
    },
    _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },
    buttonSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    buttonDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    classNames() {
      return [
        "el-button",
        this.type ? "el-button--" + this.type : "",
        this.buttonSize ? "el-button--" + this.buttonSize : "",
        {
          "is-disabled": this.buttonDisabled,
          "is-loading": this.loading,
          "is-plain": this.plain,
          "is-round": this.round,
          "is-circle": this.circle
        }
      ];
    }
  },

  methods: {
    handleClick(evt) {
      this.$emit("click", evt);
    }
  }
};
</script>

<style lang="scss" scoped>
.el-button-helper {
  display: inline-block;
}
.el-button {
  display: block;
}
</style>
